/**
 * @format
 * @flow
 */
export const GET_SETTING = 'GET_SETTING';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const GET_ENTERPRISE_CATEGORIES = 'GET_ENTERPRISE_CATEGORIES';
